import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link, withRouter, routerShape } from 'react-router';
import Immutable from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import cn from 'classnames';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { getTotalCountFromSummary, getMaterialTypeCountsForStatus } from '@bibliocommons/utils-borrowing';
import CheckedOutStatusIcon from '../CheckedOutStatusIcon';
import BorrowingStatus from '../../shared/BorrowingStatus';
import NextDueDate from '../NextDueDate';
import CheckedOutSidebarLink from '../CheckedOutSidebarLink';
import SidebarCompactTitle from '../../sidebar/SidebarCompactTitle';
import AllSidebarLink from '../../sidebar/AllSidebarLink';

import './CheckedOutStatus.scss';

const STATUS_ORDER = ['OVERDUE', 'COMING_DUE', 'OUT'];

export class CheckedOutStatus extends BcReactComponent {
  constructor(props) {
    super(props);
    this.bindAll('renderGrouping');
  }

  getTotalCount() {
    return getTotalCountFromSummary(this.props.summary);
  }

  renderAllItemsButton(groupedCheckouts) {
    if (groupedCheckouts.size > 1) {
      return (
        <AllSidebarLink to="/v2/checkedout" selected={this.noStatusIsSelected()} />
      );
    }

    return null;
  }

  statusIsActive(status) {
    return this.props.router.location.pathname.includes(`v2/checkedout/${status.toLowerCase()}`);
  }

  noStatusIsSelected() {
    return this.props.router.location.pathname === '/v2/checkedout';
  }

  renderGrouping(status) {
    const nextDue = this.props.summary.get('nextDue');

    return (
      <CheckedOutSidebarLink
        key={`checkedout-sidebar-link-${status}`}
        summary={this.props.summary}
        status={status}
        selected={this.statusIsActive(status)}
        nextDue={nextDue} />
    );
  }

  renderFullStatus() {
    const statusSummaries = this.props.summary.get('status', Immutable.Map());

    return (
      <span>
        <Link
          className="section-title"
          to="/v2/checkedout">
          <FormattedMessage id="section_title_checkedout" />
          <span className="pull-right" data-test-id="total-items-count">
            {this.getTotalCount()}
          </span>
        </Link>
        {this.renderAllItemsButton(statusSummaries)}
        {statusSummaries
          .map((summary, status) => status)
          .toList()
          .sortBy(status => STATUS_ORDER.indexOf(status))
          .map(this.renderGrouping)
          .toArray()}
      </span>
    );
  }

  renderNextDue() {
    const nextDue = this.props.summary.get('nextDue');
    return nextDue && nextDue.get('status') && (
      <span className={cn(nextDue.get('status').toLowerCase())}>
        <div className="checkedout-status-icon">
          <CheckedOutStatusIcon status={nextDue.get('status')} />
        </div>
        <NextDueDate date={nextDue.get('date')} />
      </span>
    );
  }

  renderOverdueCount() {
    const statusSummaries = this.props.summary.get('status', Immutable.Map());
    return statusSummaries.get('OVERDUE') && (
      <span className="overdue">
        <div className="checkedout-status-icon status-icon">
          <CheckedOutStatusIcon status="OVERDUE" />
        </div>
        {getMaterialTypeCountsForStatus(this.props.summary, 'OVERDUE')}
      </span>
    );
  }

  renderCompactStatus() {
    const overDueCount = this.renderOverdueCount();
    const nextDue = this.renderNextDue();

    return (
      <span>
        <SidebarCompactTitle
          title={<FormattedMessage id="section_title_checkedout" />}
          count={this.getTotalCount()} />
        {(overDueCount || nextDue) && (
          <div className="small checkedout-status">
            {overDueCount}
            {nextDue}
          </div>
        )}
      </span>
    );
  }

  render() {
    return (
      <BorrowingStatus to="/v2/checkedout" className="cp-checked-out-status" currentSection={this.props.currentSection}>
        {this.props.currentSection ?
          this.renderFullStatus() :
          this.renderCompactStatus()}
      </BorrowingStatus>
    );
  }
}

CheckedOutStatus.PropTypes = {
  summary: ImmutablePropTypes.mapContains({
    nextDue: ImmutablePropTypes.mapContains({
      date: PropTypes.string,
      status: PropTypes.string
    }),
    status: ImmutablePropTypes.mapOf(PropTypes.number, PropTypes.string),
    router: routerShape
  })
};

export default withRouter(CheckedOutStatus);



// WEBPACK FOOTER //
// ./app/components/borrowing/checkouts/CheckedOutStatus/CheckedOutStatus.jsx